import store from '../store/store';
import updateTelemetryForSuggestionOnSuggestionRejected from '../telemetryHelpers/updateTelemetryForSuggestionOnSuggestionRejected';
import { addRecentlyRejectedSuggestionsTelemetry } from '../actions/smartComposePluginActions';
import { RejectionReason } from '@qas/smartcompose-tslibrary/dist/src/smartComposeInteraction';

// The user has done something to invalidate the suggestion that was not normal typing.
// This could be: moving the insertion point, moving focus out of the editor, or sending the mail
export default function logImplicitRejectionIfNecessary() {
    const currentlyShownSuggestion = store().viewState.currentlyShownSuggestion;
    if (currentlyShownSuggestion) {
        updateTelemetryForSuggestionOnSuggestionRejected(
            currentlyShownSuggestion.suggestionTelemetry,
            RejectionReason.ImplicitRejection
        );
        addRecentlyRejectedSuggestionsTelemetry(currentlyShownSuggestion.suggestionTelemetry);
    }
}
